import * as a from "react";
const l = (e) => /* @__PURE__ */ a.createElement(
  "svg",
  {
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...e
  },
  /* @__PURE__ */ a.createElement(
    "path",
    {
      d: "M12.748 6.462l-6.283 6.284a1.571 1.571 0 000 2.23l6.283 6.284a1.579 1.579 0 102.23-2.23l-2.937-2.922a.408.408 0 010-.44.394.394 0 01.251-.236h7.854a4.712 4.712 0 010 9.426h-3.141a1.571 1.571 0 000 3.142h3.141A7.853 7.853 0 0025.7 14.59a7.853 7.853 0 00-5.554-2.3h-7.854a.392.392 0 01-.361-.235.41.41 0 010-.44l3.047-2.922a1.577 1.577 0 00-2.23-2.231z",
      fill: "#2d6ded"
    }
  )
), t = l;
export {
  t as default
};
